//src/hooks/useListFolderContents.ts
import { useEffect } from 'react';
import useFolderStore from 'src/store/api/useFolderStore';

const useListSharedWithFolderContents = () => {

  const { selectedFolderId, listSharedWithFolderContents, isFetchingFolderContent, errorFetchingFolderContent, responseMessageFolderContent, responseStatusFolderContent, folderContents, folderCurrentPage, folderTotalPages, folderTotalItems, setTheSelectedFolderId, folderRowsPerPage, permissions, clearTheSelectedFolderId } = useFolderStore((state) => ({
    selectedFolderId: state.selectedFolderId,
    listSharedWithFolderContents: state.listSharedWithFolderContents,
    isFetchingFolderContent: state.isFetchingFolderContent,
    errorFetchingFolderContent: state.errorFetchingFolderContent,
    responseMessageFolderContent: state.responseMessageFolderContent,
    responseStatusFolderContent: state.responseStatusFolderContent,
    folderContents: state.folderContents,
    folderCurrentPage: state.folderCurrentPage,
    folderTotalPages: state.folderTotalPages,
    folderTotalItems: state.folderTotalItems,
    folderRowsPerPage: state.folderRowsPerPage,
    setTheSelectedFolderId: state.setTheSelectedFolderId,
    permissions: state.permissions,
    clearTheSelectedFolderId: state.clearTheSelectedFolderId,

  }));

  useEffect(() => {
    console.log("selectedFolderId: ",selectedFolderId);
     if (selectedFolderId) {
      listSharedWithFolderContents(folderCurrentPage);  // Only fetch folders if selectedItemId is not null
   }
  }, [folderCurrentPage, listSharedWithFolderContents, selectedFolderId]);  // Add selectedItemId as a dependency

  return { listSharedWithFolderContents, isFetchingFolderContent, errorFetchingFolderContent, responseMessageFolderContent, responseStatusFolderContent, folderContents, folderCurrentPage, folderTotalPages, folderTotalItems, selectedFolderId, setTheSelectedFolderId, folderRowsPerPage, permissions, clearTheSelectedFolderId};
};

export default useListSharedWithFolderContents;
